<template>
  <div>
    <div class="modal-header">
      <button type="button" class="close" @click="hide()" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title">Wyszukaj produkt</h4>
    </div>
    <div class="modal-body">
      <search-product></search-product>
    </div>
  </div>
</template>
<script>
import {mapMutations} from 'vuex';

export default {
  created() {
    this.searchProductSelectedHandler = (() => {
      this.hide();
    });
    this.$root.$on('search-product-selected', this.searchProductSelectedHandler);
  },
  beforeDestroy() {
    this.$root.$off('search-product-selected', this.searchProductSelectedHandler);
  },
  methods: {
    ...mapMutations([
      'hideModal',
    ]),
    hide() {
      this.hideModal();
    },
  },
};
</script>
